import React from 'react';

import { FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { ManagementTeam } from './ManagementTeam';
import { StaffOrganization } from './StaffOrganization';
import { IForInvestorFormSubSections } from '../forInvestorsSections';

const SUB_SECTIONS: IForInvestorFormSubSections = {
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MANAGEMENT_AND_ORGANIZATION.MANAGEMENT_TEAM]: ManagementTeam,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MANAGEMENT_AND_ORGANIZATION.STAFF_ORGANIZATION]: StaffOrganization,
};

export const ManagementAndOrganization: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
